import methods from './methods'
import props from './props'

export default {
  methods,
  props
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/components/resources/index.js